import * as Factory from 'factory.ts'
import faker from 'faker'

import { APItemTypes } from '@webapp/models/enums'
import { CostAllocationMock } from './costallocation.factory'
import { CurrencyMock } from './currency.factory'
import { CustomFieldValueMock } from './customfield.factory'
import { OneTimeOrderItemMock } from './orderItem.factory'
import { PurchaseOrderV3Mock } from './purchaseorder.factory'
import { PurchaseOrderItemSummaryMock } from './purchaseOrderItemSummary.factory'
import { VendorMock } from './vendor.factory'
import { type UnbilledItem } from '../../models'

export const UnbilledItemMock = Factory.Sync.makeFactory<UnbilledItem>({
  archived: false,
  bill: Factory.each(() => faker.random.number()),
  bill_by_cost: null,
  cost_allocations: Factory.each(() => CostAllocationMock.buildList(2)),
  creditcard_item: false,
  currency: CurrencyMock.build(),
  custom_fields: CustomFieldValueMock.buildList(4),
  description: Factory.each(() => faker.commerce.productName()),
  expense: null,
  expense_report: null,
  id: Factory.each(() => faker.random.number()),
  is_edited: false,
  orderitem: Factory.each(() => OneTimeOrderItemMock.build()),
  packing_slips: [],
  po: PurchaseOrderV3Mock.build(),
  quantity: Factory.each(() => faker.commerce.price().toString()),
  received_on: Factory.each(() => faker.date.past().toISOString()),
  same_unit_cost: true,
  sku: Factory.each(() => faker.random.alphaNumeric(8)),
  shipping_amount: null,
  tax: null,
  tax_amount: 0,
  tax_is_inclusive: false,
  tax_name: null,
  tax_percentage: '0.00',
  total_cost: Factory.each(() => faker.random.number()),
  total_cost_with_tax: Factory.each(() => faker.random.number()),
  type: APItemTypes.PURCHASE_ORDER_ORDER_ITEM,
  unit: 'per',
  unit_cost: Factory.each(() => faker.random.number()),
  unit_cost_diff_log: null,
  vendor: VendorMock.build(),
  item_summary: PurchaseOrderItemSummaryMock.build(),
})
